export default __webpack_public_path__ + "assets/images/10.8f5903.png";